<template>
  <VNotification
    :item="notification"
    @toggle-read="$emit('toggle-read',notification)"
    @close="$emit('close')"
  >
    <template #header>
      <span>
        {{ $t('export_ready_to_download') }}
      </span>
    </template>
    <template #type>
      <span class="cursor-default">
        {{ $t('download') }}:
      </span>
      <span @click="onClickDownload">
        {{ notification.data?.fileName }}
      </span>
    </template>
  </VNotification>
</template>

<script>
import VNotification from '@/components/templates/notifications/VNotification.vue';
import FilesService from '@/services/hrsg/platform/FilesService';

export default {
  components: {
    VNotification
  },
  props: {
    notification: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['toggle-read', 'close'],
  setup (props) {
    const onClickDownload = async () => {
      await FilesService.downloadUuid(props.notification.data?.fileId);
    };

    return {
      onClickDownload
    };
  }
};
</script>
